module.exports = "/_next/static/images/mduServices-531e1457dc4966c9a49b511a445d02c5.webp";